import React, { useState } from 'react';
import { Lock, ArrowRight } from 'lucide-react';
import { LENDER_BLUE, LENDER_NAVY, LENDER_DEMO_PASSCODE, isLenderUnlocked, unlockLender } from '@/lib/lenderDemo';

// Lightweight passcode gate so a client/visitor can't stumble into the lender
// demo. Session-scoped (re-locks when the tab closes). This is presentation
// gating, not security — the demo carries no real customer data.
export default function LenderGate({ children }) {
  const [unlocked, setUnlocked] = useState(isLenderUnlocked());
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  if (unlocked) return children;

  const submit = (e) => {
    e.preventDefault();
    if (code.trim().toLowerCase() === LENDER_DEMO_PASSCODE.toLowerCase()) {
      unlockLender();
      setUnlocked(true);
    } else {
      setError('Incorrect passcode. Please try again.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#F3F5F9' }} className="flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl p-7 text-center" data-testid="lender-gate">
        <div className="inline-flex items-center gap-2 mb-5">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center text-white font-bold" style={{ background: LENDER_BLUE }}>D</div>
          <span className="text-xl font-bold" style={{ color: LENDER_NAVY }}>DrawReady</span>
        </div>
        <div className="w-11 h-11 rounded-full mx-auto mb-3 flex items-center justify-center" style={{ background: '#EEF3FF', color: LENDER_BLUE }}>
          <Lock className="w-5 h-5" />
        </div>
        <h1 className="text-lg font-bold mb-1" style={{ color: LENDER_NAVY }}>Lender demo</h1>
        <p className="text-sm text-slate-500 mb-5">Enter the passcode to open the demo.</p>
        <input
          type="password"
          value={code}
          autoFocus
          onChange={(e) => { setCode(e.target.value); setError(''); }}
          data-testid="lender-gate-input"
          placeholder="Passcode"
          className="w-full mb-3 px-3 py-2.5 text-sm text-center border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200"
        />
        {error && <p className="text-xs text-red-500 mb-3" data-testid="lender-gate-error">{error}</p>}
        <button
          type="submit"
          data-testid="lender-gate-submit"
          className="w-full flex items-center justify-center gap-1.5 py-2.5 text-sm font-semibold text-white rounded-lg"
          style={{ background: LENDER_BLUE }}
        >
          Enter demo <ArrowRight className="w-4 h-4" />
        </button>
      </form>
    </div>
  );
}
